module.exports = __webpack_public_path__ + "2380a81363642ba7318680e2bed1b3c6.MP3";